import { http } from './http'

export const getSubscriptions = () => {
  return http().get('/api/subscriptions')
}

export const unsubscribe = (subscriptionId, ends_at) => {
  return http().put(`/api/subscriptions/${subscriptionId}/unsubscribe`, { ends_at })
}
